import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Subscription } from '@/types/subscriptions/subscription';
import { Spinner } from '@/components/shared/Spinner';
import { StyledItemGroup } from './StyledItemGroup';

type Props = {
  isLoading: boolean;
  subscriptions: Subscription[];
};

export const SubscriptionListContents: React.FC<Props> = (props) => {
  const { isLoading = false, subscriptions = [] } = props;
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <StyledLoader>
        <Spinner size="small" />
      </StyledLoader>
    );
  }

  if (subscriptions.length === 0) {
    return <>{t('ui.subscription.index.empty')}</>;
  }

  return <StyledItemGroup subscriptions={subscriptions} />;
};

const StyledLoader = styled.div`
  display: flex;
  height: 10em;
  align-items: center;
  justify-content: center;
`;
